import AdvocateAvadhaniDetails from '../../components/about/advocates-details/avadani';
import Footer from '../../components/common/footer';
import Layout from '../../components/common/layout';
import NavigationMenu from '../../components/common/navigationMenu';
import PageHeader from '../../components/common/pageHeader';
import React from 'react';

const AdvocateAvadhaniDetailsPage = () => {
  return (
    <Layout pageTitle='Avadhani & Associates | V. S. R. Avadhani'>
      <NavigationMenu active='about' />
      <PageHeader
        title='V. S. R. Avadhani'
        subMenu='Advocates'
        backLink='/about#team-section'
      />
      <AdvocateAvadhaniDetails />
      <Footer />
    </Layout>
  );
};

export default AdvocateAvadhaniDetailsPage;
